import Gradient from 'ink-gradient';
import Bar from '../../../libs/ink-progress-bar';

interface ProgressBarProps {
  left?: number;
  right?: number;
  percent: number;
}

export default function ProgressBar({
  left,
  right,
  percent,
}: ProgressBarProps) {
  return (
    <Gradient colors={['gray', 'white']}>
      <Bar left={left} right={right} percent={percent} />
    </Gradient>
  );
}
